import React from 'react';
// FloatingFooter component
const FloatingFooter = ({ hasChanges, onSave, saveLabel = "Save", multipleSave = false, onSaveContinue, onSaveExit }) => {
  // if multipleSave ==  true then it will have two save button
  // Internal handleUndo function to refresh the page
  const handleUndo = () => {
    window.location.reload(); // Refresh page
  };

  return (
    <div
      className="fixed bottom-0 left-0 w-full border-t border-[#e6ebf7] bg-white/92 py-3 shadow-[0_-12px_28px_rgba(15,23,42,0.05)] backdrop-blur-xl flex justify-center md:justify-center"
    >
      <div className="w-[97%] max-w-[1520px] mx-auto flex justify-end gap-8">
        {/* Use space-x-4 to add horizontal space between buttons */}
        <button
          type="button"
          onClick={handleUndo} // Call handle Undo on click
          className={`cms-button-text h-11 w-36 rounded-[14px] px-6 focus:outline-none focus:ring-2 focus:ring-offset-2 whitespace-nowrap transition-all duration-200 ${hasChanges
            ? 'border border-[#d8e1f8] bg-white text-[#31415d] hover:-translate-y-0.5 hover:border-[#c5d1f5] hover:bg-[#fbfcff] hover:shadow-[0_10px_20px_rgba(15,23,42,0.05)] focus:ring-[rgba(74,92,255,0.08)]'
            : 'border border-[#e5e7eb] bg-[#f3f4f6] text-gray-400 cursor-not-allowed'
            }`}
          disabled={!hasChanges}
        >
          Cancel
        </button>
        {!multipleSave &&
          <button
            type="button"
            onClick={onSave} // Call onSave passed from the parent component
            className={`cms-button-text h-11 w-36 rounded-[14px] px-6 focus:outline-none focus:ring-2 focus:ring-offset-2 whitespace-nowrap transition-all duration-200 ${hasChanges
              ? 'border border-[#4a5cff] bg-[#4a5cff] text-white hover:-translate-y-0.5 hover:bg-[#3f50ea] hover:shadow-[0_14px_28px_rgba(74,92,255,0.2)] focus:ring-[rgba(74,92,255,0.12)]'
              : 'border border-[#e5e7eb] bg-[#f3f4f6] text-gray-400 cursor-not-allowed'
              }`}
            disabled={!hasChanges}
          >
            {saveLabel} {/* Display the label dynamically */}
          </button>}
        {multipleSave && (
          <button
            type="button"
            onClick={onSaveContinue} // Call onSave passed from the parent component
            className={`cms-button-text h-11 w-36 rounded-[14px] px-1 focus:outline-none focus:ring-2 focus:ring-offset-2 whitespace-nowrap transition-all duration-200 ${hasChanges
              ? 'border border-[#4a5cff] bg-[#4a5cff] text-white hover:-translate-y-0.5 hover:bg-[#3f50ea] hover:shadow-[0_14px_28px_rgba(74,92,255,0.2)] focus:ring-[rgba(74,92,255,0.12)]'
              : 'border border-[#e5e7eb] bg-[#f3f4f6] text-gray-400 cursor-not-allowed'
               }`}
            disabled={!hasChanges}
          >
            Save & Continue
          </button>)}
        {multipleSave && (
          <button
            type="button"
            onClick={onSaveExit} // Call onSave passed from the parent component
            className={`cms-button-text h-11 w-36 rounded-[14px] px-1 focus:outline-none focus:ring-2 focus:ring-offset-2 whitespace-nowrap transition-all duration-200 ${hasChanges
              ? 'border border-[#4a5cff] bg-[#4a5cff] text-white hover:-translate-y-0.5 hover:bg-[#3f50ea] hover:shadow-[0_14px_28px_rgba(74,92,255,0.2)] focus:ring-[rgba(74,92,255,0.12)]'
              : 'border border-[#e5e7eb] bg-[#f3f4f6] text-gray-400 cursor-not-allowed'
               }`}
            disabled={!hasChanges}
          >
            Save & Exit
          </button>)}
      </div>
    </div>
  );
};

export default FloatingFooter;
